import { toJSONLocal, toLocalDate } from "../helpers/helpers";
import { Base } from "./Base";

export class FactOfTheDay extends Base {
    id: string;
    date: Date;
    header: string;
    fact: string;
    createdAt: Date;
    lastChangedAt: Date;

    constructor(i?: IFactOfTheDay) {
        super();
        if(i!=undefined) {
            this.id = i.id;
            this.date = toLocalDate(i.date);
            this.header = i.header;
            this.fact = i.fact;
            this.createdAt = new Date(i.createdAt);
            this.lastChangedAt = new Date(i.lastChangedAt);
        }
    }

    toInterface(): IFactOfTheDay {
        var ret = {} as IFactOfTheDay;
        Object.assign(ret, this);
        ret.date = toJSONLocal(this.date);
        return ret;
    }
}

export interface IFactOfTheDay {
    id: string;
    date: string;
    header: string;
    fact: string;
    createdAt: Date;
    lastChangedAt: Date;
}